import { createSlice } from '@reduxjs/toolkit'

export type AuthenticateState = boolean

const initialState: AuthenticateState = false

const authenticateSlice = createSlice({
  name: 'authenticate',
  initialState,
  reducers: {
    setSignedIn: () => true,
    setSignedOut: () => false,
  },
})

export const { setSignedIn, setSignedOut } = authenticateSlice.actions
export default authenticateSlice.reducer